import React from 'react';
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';

/**
 * Add-Text-Document dialog. Extracted from ChatbotDetailPage.jsx (iter132.2)
 * so the parent page is no longer a 1,700-line monolith. Purely
 * presentational — the parent still owns state and the submit handler.
 */
export const AddTextDocumentDialog = ({
  open,
  onOpenChange,
  newTextDoc,
  setNewTextDoc,
  onSubmit,
}) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="bg-white border-slate-200 max-w-lg">
      <DialogHeader>
        <DialogTitle className="text-slate-900">Add Text Document</DialogTitle>
      </DialogHeader>
      <div className="space-y-4 py-4">
        <div>
          <Label className="text-slate-600">Document Name</Label>
          <Input
            value={newTextDoc.name}
            onChange={(e) => setNewTextDoc({ ...newTextDoc, name: e.target.value })}
            placeholder="FAQ Document"
            className="bg-white border-slate-300 text-slate-900 placeholder:text-slate-400 mt-1"
            data-testid="text-doc-name-input"
          />
        </div>
        <div>
          <Label className="text-slate-600">Content</Label>
          <Textarea
            value={newTextDoc.content}
            onChange={(e) => setNewTextDoc({ ...newTextDoc, content: e.target.value })}
            placeholder="Enter your knowledge content here..."
            className="bg-white border-slate-300 text-slate-900 placeholder:text-slate-400 resize-none mt-1"
            rows={10}
            data-testid="text-doc-content-input"
          />
        </div>
      </div>
      <DialogFooter>
        <Button
          variant="outline"
          onClick={() => onOpenChange(false)}
          className="border-slate-300 text-slate-700"
        >
          Cancel
        </Button>
        <Button onClick={onSubmit} className="bg-blue-600 hover:bg-blue-700" data-testid="text-doc-submit-btn">
          Add Document
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);

export default AddTextDocumentDialog;
